import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { DictionaryFuelFeeService } from 'src/app/shared';
import { ErrorDialogComponent } from 'src/components/shared/error-dialog/error-dialog.component';

export interface FuelFeeDialogData {
  name: string;
  errorMessage?: string;
}

@Component({
  standalone: false,
  selector: 'app-dictionaries-fuelfees-add-new-dialog',
  templateUrl: './dictionaries-fuelfees-add-new-dialog.component.html',
  styleUrl: './dictionaries-fuelfees-add-new-dialog.component.scss',
})
export class DictionariesFuelFeesAddNewDialogComponent {
  fuelFeeForm: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DictionariesFuelFeesAddNewDialogComponent>,
    private fuelFeeService: DictionaryFuelFeeService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: FuelFeeDialogData
  ) {
    this.fuelFeeForm = new FormGroup({
      name: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(50)],
      }),
      sapName: new FormControl('', {
        validators: [Validators.required, Validators.maxLength(50)]
      })
    });
  }

  onAdd() {
    const request = {
      name: this.fuelFeeForm.controls.name.value,
      sapName: this.fuelFeeForm.controls.sapName.value
    };
    this.fuelFeeService.add(request).subscribe({
      next: (result) => {
        this.dialogRef.close(result);
      },
      error: (error) => {
        this.handleError(error);
      },
    });
  }

  private handleError(error: any) {
    this.dialog.open(ErrorDialogComponent, {
      data: { message: error.error.Message },
    });
  }
}
